import bloomLogo from './images/bloom.png'
// The app icon of the Bloom app (apps/mobile/assets/images/bloom_mark.png):
// the gold square with the white "B". Client-facing web screens use it.
import bloomMark from './images/bloom_mark.png'
import instelling from './images/instelling.png'
import terms from './images/terms.svg'
import underDevelopment from './images/misc/underDevelopment.svg'

// FB-8: the symptom pictograms, onboarding step illustrations and cycle
// artwork belonged to the client surface, which moved to the mobile app —
// they are gone from the bundle with it. Only the images the staff console
// and the auth pages still render are left.
const assets = {
  images: {
    bloomLogo,
    bloomMark,
    instelling,
    terms,
    underDevelopment,
  },
}

export default assets
